<template>
	<div class="home_sever" id="gundo">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>办公产业链服务</span>
			<div></div>
		</div>
		<div v-for="item in sverList">
			<van-panel :title="item.title">
				<div class="service">
					<div @click="goDetail(items.id,item.title)" v-for="items in item.category">
						<img :src="items.image | handleUrl" alt="">
						<span>{{items.title}}</span>
					</div>
					<div v-if="item.category.length == 17"></div>
				</div>
			</van-panel>
		</div>
		<Footbar></Footbar>
	</div>
</template>

<script>
	import Footbar from '@/components/footbar'

	export default {
    name: 'home_sever',
		data() {
			return {
				sverList: []
			}
		},
		created() {
			//第三方服务
			this.$axios.post(baseUrl + '/mobile/Category/thirdparty')
				.then((res) => {
					if (res.data.code == 2) {
						this.sverList = res.data.data
					}
				}).catch((err) => {
					console.log(err);
				});
		},
		components: {
			Footbar
		},
		methods: {
			//第三方详情
			goDetail(id,title) {
				this.$router.push({
					path: '/ser_detail',
					query: {
						id: id,
						title:title
					}
				})
			}
		},
		watch: {
      '$route'(to, from) {
        if (to.name === 'home_undete') { //跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
          let undetexY = this.$store.state.undeteY;
          console.log(undetexY) 
          //把在vuex里面的位置存入
          document.getElementById('gundo').scrollTop = undetexY

        }
      }

    },
    beforeRouteLeave(to, from, next) {
      //获取滚动条的高度
      let position = document.getElementById('gundo').scrollTop;	  
      //离开路由存起来
      if (position == null) position = 0
      this.$store.commit('undetexY', position) //离开路由时把位置存起来
      next()
    },
	}
</script>

<style scoped>
	.van-cell-group {
		text-align: left;
	}

	.home_sever {
		margin-bottom: 3.15rem;
		padding-top: 2rem;
	}

	.home_sever .service {
		display: flex;
		flex-wrap: wrap;
		border-radius: 0.3rem;
	}

	.home_sever .service div {
		display: flex;
		flex-direction: column;
		width: 33.33%;
		align-items: center;
		font-size: 0.7rem;
		padding: 0.7rem 0;
		border-bottom: 1px solid #ebedf0;
		border-right: 1px solid #ebedf0;
		box-sizing: border-box;
	}

	.home_sever .service div img {
		height: 2.5rem;
		width: 2.5rem;
		border-radius: 50%;
		margin-bottom: 0.3rem;
		object-fit: cover;
	}

	.van-cell:not(:last-child)::after {
		border: 0;
	}

	.van-panel__header {
		border-bottom: 1px solid #ebedf0;
	}
</style>



// WEBPACK FOOTER //
// src/components/home/home_sever.vue